"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllianceOrderInternalNoteInput = exports.AllianceOrderInternalNote = exports.InternalNote = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.InternalNote = typebox_1.Type.Object({
    timestamp: typebox_1.Type.String(), // Technically JSON doesn't support dates, except as ISO8601 strings
    note: typebox_1.Type.String(),
    userID: typebox_1.Type.String(),
});
exports.AllianceOrderInternalNote = typebox_1.Type.Intersect([
    exports.InternalNote,
    typebox_1.Type.Object({
        isIssue: typebox_1.Type.Boolean(),
        issueParty: typebox_1.Type.Optional(typebox_1.Type.String()),
        responsibleUserID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
        monetaryLoss: typebox_1.Type.Optional(typebox_1.Type.Number()),
    }),
]);
exports.AllianceOrderInternalNoteInput = typebox_1.Type.Object({
    note: typebox_1.Type.String(),
    isIssue: typebox_1.Type.Boolean(),
    issueParty: typebox_1.Type.Optional(typebox_1.Type.String()),
    responsibleUserID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    monetaryLoss: typebox_1.Type.Optional(typebox_1.Type.Number()),
});
//# sourceMappingURL=internal-note.js.map